import { render, staticRenderFns } from "./TestimonialsCarousel.vue?vue&type=template&id=4070c4f8&"
import script from "./TestimonialsCarousel.vue?vue&type=script&lang=js&"
export * from "./TestimonialsCarousel.vue?vue&type=script&lang=js&"
import style0 from "./TestimonialsCarousel.vue?vue&type=style&index=0&id=4070c4f8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports